// extracted by mini-css-extract-plugin
export var hidden = "_55-1";
export var leftPanel = "_55-2";
export var readonlyInspector = "_55-3";
export var rightPanel = "_55-0";